module.exports = __webpack_public_path__ + "static/img/行车不行人.dc3d0f6a.png";